import React from 'react'
import MoveDownIcon from "@mui/icons-material/MoveDown";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import AddCircleOutlineSharpIcon from "@mui/icons-material/AddCircleOutlineSharp";
import { IconButton } from '@mui/material';

const ColumnActions = ({ 
  params, 
  data, 
  handleAddRowAtIndex, 
  handleDeleteRow, 
  handleRowClone 
}) => {  

  const actionButtons = [
    {
      enabled: data?.component?.options?.enableRowAdd,
      icon: <AddCircleOutlineSharpIcon />,
      label: "add",
      onClick: (e) => {
        handleAddRowAtIndex(params?.row?.id);
      },
    },
    {
      enabled: data?.component?.options?.enableRowClone,
      icon: <MoveDownIcon />,
      label: "clone",
      onClick: () => {
        handleRowClone(params?.row?.id);
      },
    },
    {
      enabled: data?.component?.options?.enableRowDelete,
      icon: <RemoveCircleOutlineIcon />,
      label: "delete",
      onClick: () => {
        handleDeleteRow(params?.row?.id);
      },
    },
  ];

  return (
    <>
      {actionButtons
        .filter((btn) => btn.enabled)
        .map((btn) => (
          <IconButton
            key={btn.label}
            onClick={btn.onClick}
            aria-label={btn.label}
            id={`${data?.component?.sName}-${btn.label}-${params.row.id}`}
          >
            {btn.icon}
          </IconButton>
        ))}
    </>
  )
}

export default ColumnActions